import { useEffect } from "react";

import { IMPLEMENT_TYPES } from "@/features/dashboard/caminhoes/constants/implementTypes";
import { useGetTruckBrandsQuery, useLazyGetTruckModelsByBrandQuery } from "@/store";
import { transformInOptions } from "@/utils";

type UseTruckDataParams = {
  brandId: number;
};
export function useTruckData({ brandId }: UseTruckDataParams) {
  const brandsState = useGetTruckBrandsQuery(undefined, {
    selectFromResult: (state) => {
      return {
        ...state,
        data: {
          response: state.data,
          options: transformInOptions(state.data)
        }
      };
    }
  });
  const [getModelsByBrand, modelByBrandState] = useLazyGetTruckModelsByBrandQuery({
    selectFromResult: (state) => {
      return {
        ...state,
        data: {
          response: state.data,
          options: transformInOptions(state.data)
        }
      };
    }
  });

  useEffect(() => {
    if (brandId) {
      getModelsByBrand({ truckBrand: { id: brandId } });
    }
  }, [brandId]);

  return {
    state: {
      implements: IMPLEMENT_TYPES.map((item) => ({
        label: item.type,
        value: item.type
      }))
    },
    data: {
      brands: brandsState,
      modelByBrand: modelByBrandState
    }
  };
}
